var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tooltip',{attrs:{"content":_vm.row.status
      ? _vm.$companyConfiguration.cardStatuses.getStatusShowName(_vm.row.status)
      : '',"placement":"top","open-delay":100}},[_c('i',{staticClass:"fas fa-info-circle",class:{
      danger: [10,51,60].includes(_vm.row.status),
      success: [50,59,200].includes(_vm.row.status),
    }})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }